'use strict';

var util = angular.module('gymsystem.util');

util.directive('korpenmailing', ['$controller', '$route', '$window', 'server', function ($controller, $route, $window, server) {
    return {
        restrict: 'E',
        templateUrl: 'components/widgets/korpenmailing/korpenmailing.html',
        scope: {
            s: '=settings'
        },
        link: function ($scope) {
            $controller('AddCtrl', { $scope: $scope });

            $scope.postUrl = '/api/korpen/setmailing';

            $scope.getButtonText = function () {
                return "Skicka!";
            }
            $scope.possiblyClose = function () {
                $window.localStorage.KorpenMailingLastReadDate = `${new Date().yyyymmdd()} ${new Date().addMinutes(1).hhmm()}`; // Add a minute to make sure it doesn't pop up for the sender.
                $route.reload();
            }

            $scope.message = [];
            function getMessageFromAPI() {
                server.get('/api/korpen/getmailing').then(function (result) {
                    if (result.length > 0) {
                        $scope.message = result[0].value;
                    }
                })
            }
            getMessageFromAPI()

            $scope.editMessage = function () {
                $scope.fields.find(x => x.name == 'startTime').value = (new Date() > Date.newFull($scope.message.startTime) ? new Date() : Date.newFull($scope.message.startTime));
                $scope.fields.find(x => x.name == 'endTime').value = Date.newFull($scope.message.endTime);
                $scope.fields.find(x => x.name == 'message').value = $scope.message.message;
            }
            $scope.removeMessage = function () {
                server.post('/api/korpen/clearmailing').then(() => { $route.reload(); });
            }

            $scope.fields = [
                { name: 'startTime', title: 'Synlig från och med', required: true, type: 'datetime' },
                { name: 'endTime', title: 'Synlig fram till och med', required: true, type: 'datetime' },
                { name: 'message', title: 'Message', required: true, type: 'htmleditor' }
            ]
        }
    };
}])

util.controller('KorpenMailingDisplayCtrl', ['$scope', 'options', '$window', function ($scope, options, $window) {
    $scope.title = options.title;
    $scope.message = options.message;

    $scope.$on('$destroy', function () {
        $window.localStorage.KorpenMailingLastReadDate = `${new Date().yyyymmdd()} ${new Date().hhmm()}`;
    })
}])

util.controller('KorpenMailingHeaderCtrl', ['$rootScope', '$scope', 'server', function ($rootScope, $scope, server) {
    $scope.message = [];
    function getMessageFromAPI() {
        server.get('/api/korpen/getmailing').then(function (result) {
            if (result.length > 0 && Date.newFull(result[0].value.startTime) < new Date() && new Date() < Date.newFull(result[0].value.endTime)) {
                $scope.message = result;
            }
        })
    }
    getMessageFromAPI();

    $scope.getMessage = function () {
        return $scope.message;
    }

    $scope.showMessage = function () {
        $rootScope.showKorpenMailing(true); // 'true' to bypass the time based viewing check.
    }
}])
